export enum TipoComentario {
  CORREGIR_DOCUMENTOS = 'CORREGIR_DOCUMENTOS',

  ADECUAR_DATOS_SOLICITUD = 'ADECUAR_DATOS_SOLICITUD',

  REVISION_AJUSTES = 'REVISION_AJUSTES',
}
